import React, { useState } from 'react';
import { Bell, X, Check } from 'lucide-react';
import { useNotifications } from '../contexts/NotificationContext';
export function NotificationCenter() {
  const {
    notifications,
    unreadCount,
    markAsRead,
    clearAll
  } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);
  return <div className="relative" data-id="element-193">
      <button onClick={() => setIsOpen(!isOpen)} className="relative p-2 rounded-xl hover:bg-slate-100 text-slate-500 transition-colors" data-id="element-194">
        <Bell className="h-5 w-5" data-id="element-195" />
        {unreadCount > 0 && <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white" data-id="element-196"></span>}
      </button>

      {isOpen && <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} data-id="element-197"></div>
          <div className="absolute right-0 mt-2 w-80 sm:w-96 bg-white rounded-2xl shadow-xl border border-slate-100 z-50 overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-198">
            <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50" data-id="element-199">
              <h3 className="font-bold text-seform-navy" data-id="element-200">Notifiche</h3>
              {notifications.length > 0 && <button onClick={clearAll} className="text-xs text-slate-500 hover:text-seform-orange transition-colors" data-id="element-201">
                  Cancella tutto
                </button>}
            </div>

            <div className="max-h-[400px] overflow-y-auto custom-scrollbar" data-id="element-202">
              {notifications.length === 0 ? <div className="p-8 text-center text-slate-400" data-id="element-203">
                  <Bell className="h-8 w-8 mx-auto mb-2 opacity-20" data-id="element-204" />
                  <p className="text-sm" data-id="element-205">Nessuna notifica</p>
                </div> : <div className="divide-y divide-slate-50" data-id="element-206">
                  {notifications.map(notif => <div key={notif.id} className={`p-4 hover:bg-slate-50 transition-colors ${!notif.read ? 'bg-blue-50/30' : ''}`} data-id="element-207">
                      <div className="flex justify-between items-start gap-3" data-id="element-208">
                        <div className="flex-1" data-id="element-209">
                          <div className="flex items-center gap-2 mb-1" data-id="element-210">
                            {notif.type === 'urgent' && <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-211"></span>}
                            <h4 className={`text-sm font-semibold ${!notif.read ? 'text-seform-navy' : 'text-slate-600'}`} data-id="element-212">
                              {notif.title}
                            </h4>
                          </div>
                          <p className="text-xs text-slate-500 mb-2" data-id="element-213">
                            {notif.message}
                          </p>
                          <span className="text-[10px] text-slate-400" data-id="element-214">
                            {notif.date.toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                          </span>
                        </div>
                        {!notif.read && <button onClick={() => markAsRead(notif.id)} className="text-slate-400 hover:text-seform-orange p-1" title="Segna come letto" data-id="element-215">
                            <Check className="h-4 w-4" data-id="element-216" />
                          </button>}
                      </div>
                    </div>)}
                </div>}
            </div>
          </div>
        </>}
    </div>;
}